"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollapsableDraggableItem = void 0;
var core_1 = require("@dnd-kit/core");
var sortable_1 = require("@dnd-kit/sortable");
var utilities_1 = require("@dnd-kit/utilities");
var react_1 = __importStar(require("react")), react = react_1;
var styled_components_1 = __importDefault(require("styled-components"));
var globalVars_module_scss_1 = __importDefault(require("../../globalVars.module.scss"));
var Icon_1 = require("../Common/Icon");
var DraggableIconContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tbackground-color: ", ";\n\tborder-radius: 3px 3px 3px 3px;\n\tborder: 1px solid ", ";\n\twidth: 20px;\n\theight: 20px;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\t.tws-i-icon {\n\t\tcolor: ", ";\n\t}\n"], ["\n\tbackground-color: ", ";\n\tborder-radius: 3px 3px 3px 3px;\n\tborder: 1px solid ", ";\n\twidth: 20px;\n\theight: 20px;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\t.tws-i-icon {\n\t\tcolor: ", ";\n\t}\n"])), globalVars_module_scss_1.default.tertiaryGray3, globalVars_module_scss_1.default.secondaryGray2, globalVars_module_scss_1.default.mainGray);
var HandleDiv = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tpadding-left: 6px;\n\tdisplay: flex;\n\tdisplay: -webkit-box;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\n\t.tws-draggable-handle {\n\t\tcursor: move; /* fallback if grab cursor is unsupported */\n\t\tcursor: -webkit-grab;\n\t\tcursor: -moz-grab;\n\t\tcursor: grab;\n\t\tfont-size: 13.5px;\n\t}\n\n\t.tws-draggable-handle :active {\n\t\tcursor: move; /* fallback if grabbing cursor is unsupported */\n\t\tcursor: -webkit-grabbing;\n\t\tcursor: -moz-grabbing;\n\t\tcursor: grabbing;\n\t\tfont-size: 13.5px;\n\t}\n\n\t@media (max-width: 795px) {\n\t\tdisplay: none;\n\t}\n"], ["\n\tpadding-left: 6px;\n\tdisplay: flex;\n\tdisplay: -webkit-box;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flexbox;\n\n\t.tws-draggable-handle {\n\t\tcursor: move; /* fallback if grab cursor is unsupported */\n\t\tcursor: -webkit-grab;\n\t\tcursor: -moz-grab;\n\t\tcursor: grab;\n\t\tfont-size: 13.5px;\n\t}\n\n\t.tws-draggable-handle :active {\n\t\tcursor: move; /* fallback if grabbing cursor is unsupported */\n\t\tcursor: -webkit-grabbing;\n\t\tcursor: -moz-grabbing;\n\t\tcursor: grabbing;\n\t\tfont-size: 13.5px;\n\t}\n\n\t@media (max-width: 795px) {\n\t\tdisplay: none;\n\t}\n"])));
function CollapsableDraggableItem(props) {
    var _a;
    var _b = (0, sortable_1.useSortable)({
        id: props.id,
        disabled: props.disabled,
    }), attributes = _b.attributes, listeners = _b.listeners, setNodeRef = _b.setNodeRef, transform = _b.transform, transition = _b.transition, setActivatorNodeRef = _b.setActivatorNodeRef;
    var _c = react.useState(false), inDragging = _c[0], setInDragging = _c[1];
    var style = {
        transform: (_a = utilities_1.CSS.Transform.toString(transform)) === null || _a === void 0 ? void 0 : _a.replace(/scaleY\([^)]*\)/, 'scaleY(1)'),
        display: 'flex',
        position: 'relative',
        transition: transition,
        zIndex: inDragging ? 1 : 0,
    };
    (0, core_1.useDndMonitor)({
        onDragStart: function (event) {
            if (event.active.id === props.id) {
                setInDragging(true);
            }
        },
        onDragEnd: function (event) {
            setInDragging(false);
        },
    });
    return (react_1.default.createElement("div", __assign({ ref: setNodeRef, style: __assign(__assign({}, props.dragOverStyle), style) }, attributes, { id: props.id.toString(), "data-testid": 'tws-drag-container-div', className: props.className }),
        react_1.default.createElement("div", { style: __assign(__assign({}, props.dragOverStyle), { flex: 1, zIndex: 1 }) }, inDragging ? props.alterComponent : props.children),
        !props.hideHandle && (react_1.default.createElement(HandleDiv, { id: 'handle-div', "data-testid": 'tws-drag-handle-div' },
            react_1.default.createElement(DragHandle, { id: props.id, setActivatorNodeRef: setActivatorNodeRef, listeners: listeners })))));
}
exports.CollapsableDraggableItem = CollapsableDraggableItem;
function DragHandle(props) {
    return (react_1.default.createElement(DraggableIconContainer, __assign({ id: props.id ? 'draggableIcon' + props.id : 'draggableIcon', className: 'tws-draggable-handle', "data-testid": 'tws-drag-handle', ref: props.setActivatorNodeRef }, props.listeners),
        react_1.default.createElement(Icon_1.Icon, { name: 'move', title: 'move' })));
}
var templateObject_1, templateObject_2;
